/**
 * Constants and option sets for the Medicines section. The earlier hardcoded
 * MEDICINES / PAST_MEDICINES sample rows were removed once the section wired
 * up against api-medicine-v2-service.
 */

/**
 * Status bands for the dropdown chip. Only THREE states — "on-hold" from the
 * original scaffold was dropped once the design locked to ongoing / completed
 * / discontinued (matches the backend `status` enum).
 */
/* Ongoing re-inked per board 3447:6352 (2964:4139 hero table): the chip is
   the ORANGE band (#ffedd5 / #f97316), not the old green. The other two are
   not drawn on that board and keep their previous values. */
export const MEDICINE_STATUS = [
  { key: "ongoing", label: "Ongoing", bg: "#ffedd5", fg: "#f97316", dot: "#f97316" },
  { key: "completed", label: "Completed", bg: "#e0e7ff", fg: "#3730a3", dot: "#6366f1" },
  { key: "discontinued", label: "Discontinued", bg: "#fee2e2", fg: "#9b1c1c", dot: "#dc2626" },
];

export const medicineBand = (key) =>
  MEDICINE_STATUS.find((s) => s.key === key || s.label === key) || MEDICINE_STATUS[0];

/**
 * Dose-quantity quick-pick strip. Backend stores `value` as a string so the
 * ½ / 1½ fractions round-trip losslessly.
 */
export const DOSE_QUICKPICK = ["½", "1", "1½", "2", "3", "4", "5"];

/**
 * Dose-frequency times of day (multi-select). Backend field:
 * `doseFrequency.timesOfDay []string`.
 */
export const TIMES_OF_DAY = ["Morning", "Afternoon", "Evening", "Night"];

/**
 * Interval quick-picks — UI shortcuts that populate the (customValue,
 * customUnit="Hours") pair in Custom mode. No dedicated backend field:
 * `doseFrequency.customValue` / `customUnit` carries the intent on
 * the wire whether the reviewer clicks a chip or types the pair.
 */
export const INTERVAL_OPTIONS = ["4h", "6h", "8h", "12h"];

/**
 * Custom-frequency unit select. Backend field: `doseFrequency.customUnit`.
 */
export const FREQ_UNIT_OPTIONS = ["Hours", "Days", "Weeks", "Months"];

/**
 * Instructions select. Backend field: `instructions` (stores the key, e.g.
 * "before"). Labels rendered in the UI.
 */
export const INSTRUCTION_OPTIONS = [
  { key: "before", label: "Before meal" },
  { key: "with", label: "With meal" },
  { key: "after", label: "After meal" },
  { key: "after-dinner", label: "After dinner" },
  { key: "empty", label: "Empty stomach" },
  // "local" is the ointment-family case: rendered as a single full-width
  // chip and served ONLY when the formulation catalog declares it
  // (never mixed with the meal options).
  { key: "local", label: "Local Application" },
];

/**
 * Duration quick-picks. Left row = days (used with `durationDays` as-is);
 * right row = weeks/months (multiplied to days on save). Backend stores a
 * single `durationDays int`.
 */
export const DURATION_DAYS_QUICKPICK = [3, 7, 10, 14, 28];
export const DURATION_LONG_QUICKPICK = [
  { label: "1 week", days: 7 },
  { label: "2 weeks", days: 14 },
  { label: "3 weeks", days: 21 },
  { label: "4 weeks", days: 28 },
  { label: "2 months", days: 60 },
];
